export const active = 'active';
export const disabled = 'disabled';
export const assigned = 'assigned';
export const returned = 'returned';
export const suspended = 'suspended';
